__turbopack_context__.v({
  "editable": "index-module__JZkoKG__editable",
  "placeholder": "index-module__JZkoKG__placeholder",
});
